import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts';
import { Button, FileUpload, Modal, RadioButton } from '../../../../component';
import { fileManagementApi, paymentApi } from '../../../../services/apis';
import { submitPaymentForm } from '../../../../utils/consts/payment';
import { AttachIcon, CloseIcon } from '../../../../content/svg-component';
import { fileHandlerUrl } from '../../../../utils/consts/server';
import './userCreditCard.scss';

const UserCreditCard = ({
  className,
  selectedList,
  intl,
  isResetData,
  toastData,
  direction,
  navigate,
}) => {
  const [paymentType, setPaymentType] = useState('online');
  const [attachments, setAttachment] = useState([]);
  const [selectedAttachment, setSelectedAttachment] = useState('');
  const [isOpenAttachments, setIsOpenAttachment] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);

  const payWithWallet = async () => {
    setLoading(true);
    const invoiceIds = selectedList.map((item) => {
      return Number(item.id);
    });
    try {
      const { status } = await paymentApi.payWithWallet({
        data: {
          invoiceIds,
        },
      });
      if (status === 200) {
        isResetData(true);
      }
    } catch (error) {
      let alertMessage = 'user.tryagain';
      switch (error?.data?.errMessage) {
        case 'Wallet net amount is zero':
          alertMessage = 'profile.walletnotenough';
          break;
        default:
          alertMessage = 'user.tryagain';
          break;
      }
      toastData({
        toast: true,
        alertMessage,
        toastState: 'danger',
      });
    } finally {
      setLoading(false);
    }
  };

  const paymentGateway = async () => {
    setLoading(true);
    const invoiceIds = selectedList.map((item) => {
      return Number(item.id);
    });
    try {
      const {
        payload: {
          data: { url, method, inputs },
          status,
        },
      } = await paymentApi.paymentGateway({
        data: {
          invoiceIds,
          redirectUrl: `${window.location.origin}`,
        },
      });
      if (status === 200) isResetData(true);
      submitPaymentForm(url, method, inputs);
    } catch (error) {
      toastData({
        toast: true,
        alertMessage: 'user.tryagain',
        toastState: 'danger',
      });
    } finally {
      setLoading(false);
    }
  };

  const payWithBankReceipt = async () => {
    setLoading(true);
    const invoiceIds = selectedList.map((item) => {
      return Number(item.id);
    });
    try {
      const { status } = await paymentApi.payWithBankReceipt({
        data: {
          invoiceIds,
          attachments,
        },
      });
      if (status === 200) {
        isResetData(true);
        setAttachment([]);
        toastData({
          toast: true,
          alertMessage: 'tour.tourtypeinsertsuccess',
          toastState: 'success',
        });
      }
    } catch (error) {
      toastData({
        toast: true,
        alertMessage: 'user.tryagain',
        toastState: 'danger',
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteFile = (value) => {
    let index = attachments.findIndex((item) => item === value);
    fileManagementApi.deleteFile(attachments[index]);
    const updatedAttachments = attachments.filter((item) => item !== value);
    setAttachment([...updatedAttachments]);
  };

  const handlePaymentAction = () => {
    switch (paymentType) {
      case 'online':
        paymentGateway();
        break;
      case 'bank':
        payWithBankReceipt();
        break;
      case 'wallet':
        payWithWallet();
        break;
    }
  };

  let sum = 0;
  return (
    <div className="w-100 px-0 mb-4">
      <Modal
        title={intl.formatMessage({
          id: 'profile.viewfile',
        })}
        isOpen={isOpenAttachments}
        onClose={() => setIsOpenAttachment(false)}
      >
        <div className="w-100 d-flex px-0 pt-2 justify-content-center align-items-center">
          <img
            src={`${fileHandlerUrl}/file/show/${selectedAttachment}`}
            alt="image"
            className="rounded-1 col-sm-7 col-12 selected-image"
            height={400}
          />
        </div>
      </Modal>
      <div
        className={`d-flex flex-column justify-content-center align-items-center bg-primary px-0 pb-2 pt-4 ${className}`}
      >
        <div className="d-flex justify-content-center align-items-center border-bottom border-2 border-third font-smaller mb-3 px-0 pb-2 text-third">
          <FormattedMessage id="profile.selectedbills" />
        </div>
        <div className="col-12 text-third" style={{ minHeight: '20px' }}>
          {selectedList?.length > 0 &&
            selectedList?.map((item, index) => {
              sum = sum + item.totalPriceToPayment / 10;
              return (
                <div
                  className="col-12 d-flex flex-row justify-content-between align-items-center font-xsmall p-0 py-xl-1 py-2"
                  key={`totalprice-${index}`}
                >
                  <div className="col-1 p-0 text-dark text-start">
                    {index + 1}
                  </div>
                  <div className="d-flex flex-xl-row flex-md-column justify-content-between align-items-end w-100">
                    <div className="p-0 text-center">{item.invoiceNo}</div>
                    <div className="p-0 text-dark text-center">
                      {`${numberWithCommas(
                        item.totalPriceToPayment / 10,
                      )} ${intl?.formatMessage({
                        id: 'booking.toman',
                      })}`}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="w-100 d-flex flex-column justify-content-center p-0 pt-4 border-third font-xsmall text-third text-center">
          <FormattedMessage id="booking.paymentprice" />
          <span className="text-danger pt-1">
            {`${numberWithCommas(sum)} ${intl?.formatMessage({
              id: 'booking.toman',
            })}`}
          </span>
        </div>
        <div className="col-6 border-bottom pb-2 border-2 border-third" />
        <div className="d-flex col-10 p-0 text-white pt-2">
          <div className="w-100 d-flex flex-column py-2 p-0">
            <RadioButton
              key="online"
              name="online"
              label="profile.online"
              inputClassName="font-smaller border-0 text-primary"
              checked={paymentType === 'online'}
              onChange={() => setPaymentType('online')}
              isLocalization={true}
              parentInputClassName="w-75 d-flex flex-row justify-content-start align-items-center p-0 text-nowrap"
              theme="light"
            />
            <RadioButton
              key="bank"
              name="bank"
              label="profile.bankreceipt"
              inputClassName="font-smaller border-0 text-primary"
              checked={paymentType === 'bank'}
              onChange={() => setPaymentType('bank')}
              isLocalization={true}
              parentInputClassName="w-75 d-flex flex-row justify-content-start align-items-center p-0 text-nowrap"
              theme="light"
            />
            <RadioButton
              key="wallet"
              name="wallet"
              label="profile.wallet"
              inputClassName="font-smaller border-0 text-primary"
              checked={paymentType === 'wallet'}
              onChange={() => setPaymentType('wallet')}
              isLocalization={true}
              parentInputClassName="w-75 d-flex flex-row justify-content-start align-items-center p-0 text-nowrap"
              theme="light"
            />
            {paymentType === 'bank' && (
              <div className="w-100 d-flex flex-column justify-content-start px-xl-2 px-0">
                {selectedList.length > 0 && (
                  <>
                    <FileUpload
                      className="text-info mt-2 px-0 button font-msmall"
                      title={
                        <div className="text-nowrap">
                          <AttachIcon size={14} color={'#126eab'} />
                          <span className="px-2 font-xl-msmall font-md-smaller ">
                            {intl.formatMessage({
                              id: 'profile.attachedPaymentReceipt',
                            })}
                          </span>
                        </div>
                      }
                      isOptional={true}
                      recieveFile={(file) => {
                        setAttachment([...attachments, file]);
                      }}
                      customClassName="justify-content-start py-0 px-xl-2 px-0"
                      giveFeedBack={(e) => setLoadingFile(e.loadingData)}
                    />
                    {loadingFile && (
                      <span className="pb-1 text-start font-tiny text-secondary">
                        (<FormattedMessage id="booking.loading" />)
                      </span>
                    )}
                    <div className="d-flex justify-content-end pt-2 flex-wrap">
                      {attachments.map((item, index) => {
                        return (
                          <React.Fragment key={`img-upload-${index}`}>
                            <div className="position-relative factore-img mx-1 mb-2">
                              <div
                                className={`position-absolute delete-${direction}`}
                                onClick={() => {
                                  deleteFile(item);
                                }}
                              >
                                <CloseIcon size={10} color={'#dc2633'} />
                              </div>
                              <img
                                src={`${fileHandlerUrl}/file/show/${item}`}
                                className="w-100 h-100"
                                onClick={() => {
                                  setSelectedAttachment(item),
                                    setIsOpenAttachment(true);
                                }}
                              />
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            )}
            <Button
              name={`payment-bills`}
              id={`payment-bills`}
              label={intl.formatMessage({
                id:
                  paymentType === 'bank'
                    ? `profile.${
                        attachments.length > 1 ? 'sendfiles' : 'sendfile'
                      }`
                    : 'profile.paymentbills',
              })}
              className="btn-secondary mt-2"
              onClick={() => handlePaymentAction()}
              disabled={
                loading
                  ? loading
                  : paymentType === 'bank'
                  ? attachments.length === 0
                  : selectedList.length === 0
              }
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCreditCard;
